import _ from 'lodash'

export default {
  methods: {
    raiseHttpError(response) {
      let message = null
      if (this.isHttpError(response)) {
        if (this.isHttpWithErrorMessage(response)) {
          message = this.getHttpErrorMessage(response)
        } else if (this.isHttpWithStatusMessage(response)) {
          message = this.getHttpStatusMessage(response)
        }
      }

      if (!message) {
        return false
      }

      this.$alertify.error(message)

      return true
    },
    isHttpError(response) {
      return this.isHttpClientError(response)
        || this.isHttpClientError(response)
        || this.isHttpServerError(response)
    },
    isHttpSuccess(response) {
      const status = this.getHttpStatusCode(response)
      return status >= 200 && status <= 299
    },
    isHttpRedirection(response) {
      const status = this.getHttpStatusCode(response)
      return status >= 300 && status <= 399
    },
    isHttpClientError(response) {
      const status = this.getHttpStatusCode(response)
      return status >= 400 && status <= 499
    },
    isHttpServerError(response) {
      const status = this.getHttpStatusCode(response)
      return status >= 500 && status <= 599
    },
    isHttpWithStatusMessage(response) {
      return !!this.getHttpStatusMessage(response)
    },
    getHttpStatusMessage(response) {
      const code  = this.getHttpStatusCode(response)
      const text = this.getHttpStatusText(response)

      if (!code && !text) {
        return null
      }

      return `${code}: ${text}`
    },
    getHttpStatusCode(response) {
      const actualResponse = this.getActualResponse(response)
      if (_.has(actualResponse, 'status')) {
        return _.get(actualResponse, 'status')
      } else if (_.has(actualResponse, 'httpStatus')) {
        return _.get(actualResponse, 'status')
      }
    },
    getHttpStatusText(response) {
      return _.get(this.getActualResponse(response), 'statusText')
    },
    isHttpWithErrorMessage(response) {
      return !!this.getHttpErrorMessage(response)
    },
    getHttpErrorMessage(response) {
      const title  = _.get(this.getActualResponse(response), 'data.title')
      const detail = _.get(this.getActualResponse(response), 'data.detail')

      const msg = _.chain([title, detail])
        .filter(_.isString)
        .filter(s => s !== '')
        .join(': ')
        .value()

      return msg || null
    },
    isHttpWithRedirect(response) {
      return !!this.getHttpRedirect(response)
    },
    redirectHttpRequest(response) {
      const redirect = this.getHttpRedirect(response)

      if (!redirect) {
        return false
      }

      window.location.href = redirect

      return true
    },
    getHttpRedirect(response) {
      return _.get(this.getActualResponse(response), 'data.redirect')
    }
  }
}
